export default __webpack_public_path__ + "static/media/l1.844ea0d3.png";